module.exports = __webpack_public_path__ + "img/iconos-03.0b1f6aa4.png";